import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-gestione',
  templateUrl: './gestione.component.html',
  styleUrls: ['./gestione.component.css']
})
export class GestioneComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
